import { __read } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import { Box } from '../Box/index.js';
import { useTabsContext } from './contexts/TabsContext.js';
import { useTabListContext } from './contexts/TabsListContext.js';

var TabsUnderline = function () {
    var selectedId = useTabsContext().selectedId;
    var tabsRefs = useTabListContext().tabsRefs;
    var _a = __read(useState(0), 2), offsetWidth = _a[0], setOffsetWidth = _a[1];
    var _b = __read(useState(0), 2), offsetLeft = _b[0], setOffsetLeft = _b[1];
    useEffect(function () {
        var selectedTabRef = tabsRefs.current[selectedId];
        setOffsetWidth(selectedTabRef.offsetWidth);
        setOffsetLeft(selectedTabRef.offsetLeft);
    }, [selectedId]);
    return (jsx(Box, { themeKey: "tabListUnderline", sx: {
            width: "".concat(offsetWidth, "px"),
            transform: "translateX(".concat(offsetLeft, "px)"),
        } }));
};

export { TabsUnderline };
//# sourceMappingURL=TabsUnderline.js.map
